import React, { useEffect, useState } from 'react'
import {
  Typography,
  Table,
  Avatar,
  Button,
  Form,
  Modal,
  Input,
  Switch
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  PlusOutlined,
  UserOutlined,
} from '@ant-design/icons'
import Spinner from '../../components/Spinner'
import { DateTime } from 'luxon'
import { FlexSectionHeader } from '../style'
import {
  createCategory,
  getAllCategory,
  toggleCategoryStatus
} from '../../reducers/courseCategoryReducer'

const { Title, Text } = Typography
const { Column } = Table

const Category = () => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)

  const category = useSelector((state) => state.category.data)
  const loading = useSelector((state) => state.category.loading)
  const user = useSelector((state) => state.auth.user)

  useEffect(() => {
    dispatch(getAllCategory())
  }, [])

  const handleCancel = () => {
    setModalVisible(false)
  }

  const addCategory = async (values) => {
    try {
      const payload = {
        categoryName: values.category,
        createdBy: user?._id,
        user: {
          _id: user?._id,
          name: user?.name,
          email: user?.email,
          role: user?.role,
          photo: user?.photo
        }
      }

      const res = dispatch(createCategory(payload))
      if (res) {
        dispatch(getAllCategory())
        setModalVisible(false)
        form.resetFields()
      }
    } catch (err) {
      console.error('Create category failed:', err)
    }
  }

  if (loading) return <Spinner size="large" />

  return (
    <>
      <FlexSectionHeader>
        <Title level={3}>All Categories</Title>
        <Button
          onClick={() => setModalVisible(true)}
          type="dashed"
          shape="round"
          style={{ height: '40px' }}
          icon={<PlusOutlined />}
        >
          Add Category
        </Button>
      </FlexSectionHeader>

      <Modal
        title="Add New Category"
        visible={modalVisible}
        onOk={form.submit}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={form.submit}>
            Submit
          </Button>
        ]}
      >
        <Form
          name="add Category"
          form={form}
          onFinish={addCategory}
          requiredMark={false}
          layout="vertical"
        >
          <Form.Item
            name="category"
            rules={[
              { required: true, message: 'Please enter category name' },
              { min: 3, message: 'Category must contain at least 3 characters' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Enter category name"
            />
          </Form.Item>
        </Form>
      </Modal>

      <Table
        pagination={false}
        style={{ marginTop: '24px' }}
        rowKey={(cat) => cat.id}
        dataSource={category}
      >
        <Column
          title="Photo"
          dataIndex={['user', 'photo']}
          key="photo"
          render={(img) => <Avatar src={img} icon={!img && <UserOutlined />} />}
        />

        <Column
          title="Category Name"
          dataIndex="categoryName"
          key="categoryName"
        />

        <Column title="Email" dataIndex={['user', 'email']} key="email" />

        <Column title="Created By" dataIndex={['user', 'name']} key="name" />

        <Column
          title="Status"
          dataIndex="isActive"
          key="isActive"
          render={(isActive, record) => (
            <Switch
              checked={isActive}
              onChange={() => dispatch(toggleCategoryStatus(record.id))}
            />
          )}
        />
      </Table>
    </>
  )
}

export default Category
